import { ListItemProps } from "./detroit-shade.types"
import { CheckCircledIcon } from "@radix-ui/react-icons"
import BasicLink from "../shared/basic-link"

const BulletList = ({ text, link }: ListItemProps) => (
  <li className="flex pb-4">
    <CheckCircledIcon className="ml-2 mr-2 mt-1 shrink-0" />
    <span>
      {text}
      {link && (
        <>
          {" "}
          <BasicLink url={link.url} text={link.text} />
        </>
      )}
      .
    </span>
  </li>
)

export default BulletList
